import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { translate } from "../core/i18n";
import { useDeleteProject } from "../hooks/useDeleteProject";

interface DeleteProjectButtonProps {
  projectId?: string;
  projectName?: string;
  onDeleted?: () => void;
  className?: string;
  showText?: boolean;
}

export const DeleteProjectButton: React.FC<DeleteProjectButtonProps> = ({
  projectId,
  projectName,
  onDeleted,
  className = "",
  showText = false
}) => {
  const { requestDeleteProject } = useDeleteProject({ projectId, projectName, onDeleted });

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation(); // Prevent triggering parent click handlers
    requestDeleteProject();
  };

  return (
    <button
      className={`btn btn-sm btn-outline-danger delete-project-btn ${className}`}
      onClick={handleClick}
      title={translate("delete-project-title")}
      onMouseEnter={(e) => {
        e.currentTarget.classList.add("btn-danger");
        e.currentTarget.classList.remove("btn-outline-danger");
      }}
      onMouseLeave={(e) => {
        e.currentTarget.classList.remove("btn-danger");
        e.currentTarget.classList.add("btn-outline-danger");
      }}
    >
      <FontAwesomeIcon icon="trash" />
      {showText && <span className="ms-1">{translate("delete-project-menu")}</span>}
    </button>
  );
};

